import type { CartItem } from '@/app/services/pos.service'
import type { SaleDetail } from '@/app/services/sales.service'

export function saleItemsForTicket(saleDetail: SaleDetail): CartItem[] {
  return saleDetail.items.map((item) => {
    const quantity = Number(item.quantity)
    const subtotal = Number(item.subtotal)
    const discount = Number(item.discount_amount)
    const tax = Number(item.tax_amount || 0)
    const total = Number(item.total)
    const savings = Number(item.savings_amount ?? item.discount_amount)
    const regularTotal = Number(item.regular_total ?? total + savings)
    const snapshot = item.discount_snapshot

    return {
      id: item.product_id || item.id,
      product_id: item.product_id,
      name: item.product_name,
      code: '',
      quantity,
      price: Number(item.unit_price),
      stock: 0,
      selected: false,
      version: 1,
      requiresPrescription: false,
      amounts: {
        regular_unit_subtotal: item.unit_price,
        applied_unit_subtotal: quantity > 0 ? (subtotal - discount) / quantity : 0,
        applied_unit_total: quantity > 0 ? total / quantity : 0,
        subtotal,
        discount_total: discount,
        taxable_subtotal: subtotal - discount,
        tax_total: tax,
        total,
        regular_total: regularTotal,
        savings_total: savings,
      },
      pricing: snapshot
        ? {
            source: 'promotion',
            promotion_id: item.promotion_id ?? snapshot.promotion_id,
            promotion_name: snapshot.name,
            promotion_type: snapshot.type,
            value: snapshot.value,
            fixed_application: snapshot.fixed_application,
            buy_quantity: snapshot.buy_quantity,
            pay_quantity: snapshot.pay_quantity,
            channel: snapshot.channel,
            starts_at: snapshot.starts_at,
            ends_at: snapshot.ends_at,
          }
        : {
            source: item.discount_type === 'quantity_tier' ? 'quantity_tier' : 'base_price',
          },
    }
  })
}
